import React from 'react'
import Simg1 from "../../../../assets/Suggestion/img-1.jpg"
import Simg2 from "../../../../assets/Suggestion/img-2.jpg"
import "../Suggestion/Sugg.css"
import InviteRelativeAction from "./InviteRelativeAction"
import FeedbackAction from "./FeedbackAction"

const Sugg = () => {
  return (
    <div className="Sugg-comp">
      <h2></h2>

      <div className="sugg-people">
        
        <div className="s-right">
          
        <FeedbackAction
        />
        <InviteRelativeAction
        />
        </div>
      </div>
    </div>
  )
}

export default Sugg 